import { render } from "./ListItemsSection.vue?vue&type=template&id=6b3d6488"
import script from "./ListItemsSection.vue?vue&type=script&lang=js"
export * from "./ListItemsSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__